












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ImageModal extends Vue {
  @Prop({ required: true })
  public src!: string;

  @Prop({ required: true })
  public visible!: boolean;

  public hide() {
    this.$emit('hide');
  }
}
